/**
 * @file index.tsx
 *
 * @fileoverview Custom events for any project should go here.
 *
 * Exemple :
 *
 * ```
 * export enum CUSTOM_EVENT_TYPES {
 *  MADE_UP,
 * }
 *
 * export enum CUSTOM_DIMENSIONS {
 *  madeUpDimension,
 * }
 *
 * export const customEvents = {
 *  MADEUP_EVENT: {
 *    key: 'madeup_event',
 *    description: 'A made up event',
 *    type: CUSTOM_EVENT_TYPES.MADE_UP,
 *  },
 * };
 * ```
 */

export enum CUSTOM_EVENT_TYPES {}
export enum CUSTOM_DIMENSIONS {}
export const CUSTOM_NUMERIC_DIMENSIONS = [];
export const customEvents = {};
